import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import './index.css';
import './i18n';
import { App } from './App';
import { AuthProvider } from './auth/AuthProvider';
import { getTheme, setTheme } from './lib/theme';

setTheme(getTheme());

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: unknown) => {
        // Don't retry on auth/permission/validation errors — they won't fix themselves
        const e = error as { kind?: string };
        if (e?.kind === 'forbidden' || e?.kind === 'unauthorized' || e?.kind === 'not_found' || e?.kind === 'validation') {
          return false;
        }
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root not found');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
